'use client'

import { ErrorFallback } from '@/components/errors/error-fallback'

export default function GlobalError({
  error,
  unstable_retry,
  reset,
}: {
  error: Error & { digest?: string }
  unstable_retry?: () => void
  reset?: () => void
}) {
  return (
    <html lang="en">
      <body className="bb-shell min-h-screen bg-[var(--bb-background)] text-[var(--bb-foreground)]">
        <ErrorFallback error={error} unstable_retry={unstable_retry} reset={reset} area="global" route="/" />
      </body>
    </html>
  )
}
